<template>
    <div class="md-layout">
        <div class="md-layout-item md-small-size-100">
            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-green">
                    <div class="card-icon">
                        <md-icon>tag</md-icon>
                    </div>
                    <h4 class="title">Edit District Type</h4>
                </md-card-header>

                <form @submit.prevent="update">
                    <md-card-content>
                        <div class="text-right">
                            <md-button @click="goBack" class="md-primary md-dense">
                                Back to List
                            </md-button>
                        </div>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Name
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="districtType.name" />
                                    <validation-error :errors="apiValidationErrors.name" />
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                short Name
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="districtType.short_name" />
                                    <validation-error :errors="apiValidationErrors.short_name" />
                                </md-field>
                            </div>
                        </div>

                    </md-card-content>

                    <md-card-actions md-alignment="right">
                        <md-button type="submit" class="md-success">Update  Type</md-button>
                    </md-card-actions>
                </form>
            </md-card>
        </div>
    </div>
</template>

<script>
import { ValidationError } from '@/components';
import formMixin from '@/mixins/form-mixin';

export default {
    components: { ValidationError },

    mixins: [formMixin],

    data: () => ({
        districtType: {
            type:'districtTypes',
            name:null,
            short_name:null,
        },
    }),

    created () {
        this.get();
    },

    methods: {
        async get () {
            try {
                const id = this.$route.params.id;
                await this.$store.dispatch('districtTypes/get', id);
                this.districtType = this.$store.getters['districtTypes/districtType'];
            } catch (e) {
                await this.$store.dispatch(
                    'alerts/error',
                    'Oops, something went wrong!'
                );
            }
        },

        async update () {
            try {
                await this.$store.dispatch('districtTypes/update', this.districtType);
                await this.$store.dispatch(
                    'alerts/success',
                    'District updated successfully.'
                );
                this.goBack();
            } catch (e) {
                if (e.response.data.errors[0]) {
                    await this.$store.dispatch(
                        'alerts/error',
                        e.response.data.errors[0].title
                    );
                    this.setApiValidation(e.response.data.errors);
                } else {
                    await this.$store.dispatch(
                        'alerts/error',
                        'Oops, something went wrong!'
                    );
                }
            }
        },

        goBack () {
            this.$router.push({ name: 'District Types List' });
        },
    },
};
</script>
